export default function Logo() {
  return (
    <a href="#top" data-testid="brand-logo" className="block">
      <img src="/logo-green-mark.webp" alt="UCURE Professional — الشعار الرسمي" className="h-12 w-auto" />
    </a>
  );
}
